import axios from 'settings/axios'
import { apiEndpoints } from 'settings/_apiSettings'

interface Error {
  response: {
    status: number
  }
}
interface ScheduleAvailabilitiesParams {
  initialDate: string
  endDate: string
  type: 'date' | 'time'
}
export interface ScheduleAvailabilities {
  date: string
  availabilities_count: number
  weekday?: number
  time?: string
}

export const getScheduleAvailabilities = ({
  initialDate,
  endDate,
  type
}: ScheduleAvailabilitiesParams): Promise<ScheduleAvailabilities[]> => {
  const endpoint = apiEndpoints.METRICS_SCHEDULE_AVAILABILITIES as string

  const params = {
    start_date__gte: initialDate,
    start_date__lte: endDate,
    group_by: type
  }

  return new Promise<ScheduleAvailabilities[]> ((resolve, reject) => {
    axios.get<ScheduleAvailabilities[]>(endpoint, { params })
      .then(response => resolve(response.data))
      .catch((error: Error) => 
        reject(error?.response?.status)
      )
  })
}